import React, { PureComponent } from "react";
import { line } from "d3-shape";
import AxisLabel from "./AxisLabel";

const YAxis = class extends PureComponent {
  render() {
    let { 
      xScale, 
      yScale, 
      //nTicksX, 
      nTicksY, 
      width, 
      height } = this.props;

    let yTicks = yScale.ticks(nTicksY);

    let tickLines = yTicks.map(tick => {
      let scaledTick = yScale(tick);
      let x1 = xScale.range()[0],
        x2 = xScale.range()[1];

      return (
        <g key={scaledTick}>
          <line
            x1={x1}
            y1={scaledTick}
            x2={x2}
            y2={scaledTick}
            stroke="lightgray"
          />
          <AxisLabel x={width} y={scaledTick} label={tick} />
        </g>
      );
    });

    return (
      <g>
        <rect width={width} height={height} fill="none" />
        {tickLines}
      </g>
    );
  }
};

export default YAxis;
